import { Row } from 'antd';
import Image from 'global/Image';
import SecuritiesCheckbox from 'global/Securities/components/Checkbox';
import styled from 'styled-components';
import { Text } from '../styled';

export const UserInfoRow = styled(Row)`
  & > .ant-col.avatar-col > img,
  & > .ant-col.avatar-col > div {
    margin-right: 16px;
  }
`;

export const NameWrapper = styled(Row)`
  margin-bottom: 2px;

  & > p:first-child {
    margin-right: 4px;
  }
`;

export const IconVerified = styled(Image)`
  width: 12px;
  height: 12px;
  margin: 2px;
`;

export const Checkbox = styled(SecuritiesCheckbox)`
  & .ant-checkbox > .ant-checkbox-inner,
  & .ant-checkbox-checked::after {
    border-radius: 9px;
  }
`;

export const Description = styled(Text)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
